export const PersonalData = axios => ({
  update (slug, payload) {
    return axios.put(`/v1/profiles/${slug}/personal-data`, payload)
  },
  get (slug) {
    return axios.get(`/v1/profiles/${slug}/personal-data`)
  }
})
